module.exports = __webpack_public_path__ + "static/img/adv-banner.3c6e79d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/adv-banner.png
// module id = Oqw0
// module chunks = 1